import { TableCell, TableCellProps } from "@material-ui/core";

const Cell = (props: TableCellProps) => (
    <TableCell
        style={{ border: 0 }} {...props}
    />
)

export default Cell;